import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { ErrorModal } from '../../components/modals/error-modal';

import { messages } from './messages';

const mapStateToProps = (state, props) => {
  const { modalFrameworkMethods, yes, no } = props;
  return {
    modalFrameworkMethods,
    state: 'warning',
    title: <FormattedMessage {...messages.title} />,
    message: <FormattedMessage {...messages.message} />,
    buttons: [
      {
        children: <FormattedMessage {...messages.cancel} />,
        onClick: () => {
          no();
        },
      },
      {
        theme: 'primary',
        children: <FormattedMessage {...messages.yes} />,
        onClick: () => {
          yes();
        },
      },
    ],
  };
};

export const BulkPrintWarnContainer = connect(mapStateToProps)(ErrorModal);
